import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { MdUpload, MdDelete,MdArrowBack } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";
import "../add-student-details/AddStudents.css";
import AutoFaceIdCamera from "../add-student-details/AutoFaceIdCamera";
import { useLocation, useHistory, useParams } from "react-router-dom";
import "../add-student-details/StudentRegistration.css";
import "../add-student-details/LogoLoader.css";
import "../add-student-details/LogoLoaders.css";

const EditStaffDetailsE = () => {
  const location = useLocation();
  const staff_id_param = location.state || {};

  const [staff_id, setStaffId] = useState(staff_id_param.staff_id);
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [department, setDepartment] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  const [images, setImages] = useState([]);
  const [multeImage, setMulteImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [hidePreview, setHidePreview] = useState(false);
  const [allImages, setAllImages] = useState([]);

  const token = localStorage.getItem("accessToken");
  const history = useHistory();
  const { staff_id: editId } = useParams();

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    setMulteImage((prev) => [...prev, ...files]);
    if (!hidePreview) {
      setHidePreview(true);
    }
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
    if (!hidePreview) {
      setHidePreview(true);
    }
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setMulteImage((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const imagesh = await Promise.all(
        allImages.map((img) =>
          img instanceof File ? readFileAsBase64(img) : img
        )
      );

      toast.warn("Updating staff, please wait...");

// ✅ Formatted URL
      const safeUpdateUrl = `${REACT_APP_API_URL}/${API_ROUTES.update_staff}/${staff_id}`.replace(/([^:]\/)\/+/g, "$1");

      // ✅ Clean fetch call
      const response = await fetch(safeUpdateUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          staff_id,
          first_name,
          last_name,
          department,
          email,
          mobile_no,
          images: imagesh,
          password: password || undefined,
        }),
      });

      const data = await response.json().catch(() => null);

      if (response?.status === 200) {
        toast.success("Staff Updated Successfully");
        setStaffId("");
        setFirstName("");
        setLastName("");
        setDepartment("");
        setEmailId("");
        setMobileNumber("");
        setPassword("");
        setMulteImage([]);
        setAllImages([]);

        history.push("/admin/FaceDetails", { staff_id });
      } else {
        toast.error(data?.detail || "Update failed");
      }
    } catch (error) {
      console.error("Error updating staff:", error);
      toast.error("Error updating staff");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (staff_id_param) {
      fetchStaff(staff_id_param);
    }
  }, [staff_id_param]);

const fetchStaff = async (staff_id_param) => {
    const id = staff_id_param.staff_id;
    try {
      const token = localStorage.getItem("accessToken");
      
      // 1. Safely construct the URL and guarantee it has a domain
      let baseUrl = REACT_APP_API_URL || "http://127.0.0.1:8000";
      if (baseUrl.startsWith("/")) {
        baseUrl = window.location.origin + baseUrl;
      }
      
      const route = API_ROUTES.get_staff || "get_staff";
      const safeUrl = `${baseUrl}/${route}/${id}`.replace(/([^:]\/)\/+/g, "$1");

      // 2. Use native fetch to bypass Axios entirely
      const response = await fetch(safeUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch: HTTP ${response.status}`);
      }

      // 3. Parse and set the data
      const staff = await response.json();
      
      setStaffId(staff.staff_id || "");
      setFirstName(staff.first_name || "");
      setLastName(staff.last_name || "");
      setEmailId(staff.email || "");
      setMobileNumber(staff.mobile_no || "");
      setDepartment(staff.department || "");
      setPassword(staff.password || "");
      setImages(staff.image || "");
      
    } catch (error) {
      console.error("Error fetching staff:", error);
      toast.error("Failed to fetch staff details");
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container">
        
        {/* --- LEFT COLUMN: FORM FIELDS --- */}
        <div className="form-section">
                 {/* ✅ BACK BUTTON */}
          <button 
            onClick={() => history.push("/admin/editstaff")}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '20px',
              padding: 0
            }}
          >
            <MdArrowBack size={20} />
            Back to Menu
          </button>
          <h2>Edit Staff Details</h2>

          <div className="form-group">
            <label className="lebcs">Face ID</label>
            <input className="Asss" type="text" value={staff_id} onChange={(e) => setStaffId(e.target.value)} placeholder="Enter Face ID" disabled />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">First Name</label>
              <input className="Asss" type="text" placeholder="First Name" value={first_name} onChange={(e) => setFirstName(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="lebcs">Last Name</label>
              <input className="Asss" type="text" placeholder="Last Name" value={last_name} onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Department</label>
              <input className="Asss" type="text" placeholder="Department" value={department} onChange={(e) => setDepartment(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="lebcs">Email</label>
              <input className="Asss" type="email" placeholder="Email" value={email} onChange={(e) => setEmailId(e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Mobile</label>
              <input className="Asss" type="number" placeholder="Mobile Number" value={mobile_no} onChange={(e) => setMobileNumber(e.target.value)} />
            </div>

          </div>

          {/* UPDATE BUTTON ON THE LEFT */}
          <div style={{ marginTop: '30px' }}>
            <button className="upload-btn" onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '12px', fontSize: '16px' }}>
              {loading ? "Updating..." : "Update Staff"}
            </button>
          </div>
        </div>

        {/* --- RIGHT COLUMN: CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          
          {/* Base64 Preview for already existing photo */}
          {!hidePreview && images && (
            <img
              src={`data:image/png;base64,${images}`}
              alt="Current Saved Face"
              style={{ width: "150px", border: "2px solid #00bcd4", borderRadius: "50%", marginBottom: "15px", objectFit: "cover", height: "150px" }}
            />
          )}

          <AutoFaceIdCamera onImageCapture={handleImageCapture} />

          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#00bcd4',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="staff_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input className="Asss" id="staff_images" accept=".png, .jpeg, .jpg" style={{ display: "none" }} type="file" multiple onChange={handleMultipleImageChange} />
            </label>

            {/* Visual Gallery with Delete Buttons */}
            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img src={imgSrc} alt={`captured-face-${index}`} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px", border: "2px solid #00bcd4" }} />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute", top: "-6px", right: "-6px", background: "#ff4444", color: "white", border: "none",
                          borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", display: "flex", alignItems: "center",
                          justifyContent: "center", fontSize: "12px", boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditStaffDetailsE;
